/******************************************** carousel slide  ***************************************************/
document.addEventListener('DOMContentLoaded', init)

function init() {
  const carouselBlocks = document.querySelectorAll(`.wp-block-webdevia-carousel`)
  if( carouselBlocks.length ) {
    carouselBlocks.forEach( carouselBlock => {
      let carouselSwiper = new Swiper( ".wp-block-webdevia-carousel", JSON.parse( carouselBlock.dataset.options ) )
    } )
  }
}
